import { Group } from "@mantine/core"
import type { PropsWithChildren } from "react"

export function StageControls({ children }: PropsWithChildren) {
  return (
    <Group mt="auto" wrap="nowrap">
      {children}
    </Group>
  )
}
